module.exports = __webpack_public_path__ + "4aed26e5ea8645607a6539159015e299.svg";